/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'code': {
    width: 16,
    height: 16,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M20.246 36l9.414-24h2.486L22.76 36h-2.514zM9 25.63l11 6.359v-2.663l-7.887-4.445L20 20.673v-2.657L9 24.134v1.496zm22.937-5.425l-.831 2.125 4.78 2.551-7.411 4.178L28 30.273v1.716l11-6.359v-1.496l-7.063-3.929z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/code.js